import { template as _$template } from "solid-js/web";
import { setAttribute as _$setAttribute } from "solid-js/web";
import { effect as _$effect } from "solid-js/web";
var _tmpl$ = /*#__PURE__*/_$template(`<div class=screen-viewer><img class=screen-viewer__image>`);
/** Full-size, pixel-crisp render of a baked `.SCR` screen. */
export function ScreenViewer(props) {
  return (() => {
    var _el$ = _tmpl$(),
      _el$2 = _el$.firstChild;
    _$effect(_p$ => {
      var _v$ = `/baked/${props.entry.path}`,
        _v$2 = props.entry.id;
      _v$ !== _p$.e && _$setAttribute(_el$2, "src", _p$.e = _v$);
      _v$2 !== _p$.t && _$setAttribute(_el$2, "alt", _p$.t = _v$2);
      return _p$;
    }, {
      e: undefined,
      t: undefined
    });
    return _el$;
  })();
}